(function() {
  if (window.__sjsProductCardScriptLoaded) return;
  window.__sjsProductCardScriptLoaded = true;

  document.addEventListener('click', function(e) {
    // 1. Wishlist Heart Button
    var heart = e.target.closest('[data-sjs-wishlist]');
    if (heart) {
      e.preventDefault();
      e.stopPropagation();
      var id = heart.getAttribute('data-sjs-wishlist');
      if (!id) return;
      try {
        var raw = localStorage.getItem('sjs_wl') || '[]';
        var list = JSON.parse(raw);
        var idx = list.indexOf(id);
        if (idx > -1) {
          list.splice(idx, 1);
          heart.classList.remove('sjs-active');
        } else {
          list.push(id);
          heart.classList.add('sjs-active');
        }
        localStorage.setItem('sjs_wl', JSON.stringify(list));
      } catch(err) {}
      return;
    }

    // 2. Add to Bag Button
    var atb = e.target.closest('[data-sjs-atb]');
    if (atb) {
      e.preventDefault();
      if (atb.disabled || atb.classList.contains('sjs-loading')) return;

      var variantId = atb.getAttribute('data-sjs-atb');
      if (!variantId) return;

      var btnText = atb.querySelector('.sjs-pc__atb-text');
      var origText = btnText ? btnText.textContent : 'ADD TO BAG';

      atb.classList.add('sjs-loading');
      atb.disabled = true;

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: [{ id: parseInt(variantId, 10), quantity: 1 }] })
      })
      .then(function(res) {
        if (!res.ok) return res.json().then(function(err) { throw err; });
        return res.json();
      })
      .then(function(data) {
        if (btnText) btnText.textContent = 'ADDED';
        setTimeout(function() {
          if (btnText) btnText.textContent = origText;
        }, 1800);

        // Notify theme cart drawer if present
        document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
        document.dispatchEvent(new CustomEvent('cart:updated', { bubbles: true }));
        if (typeof window.refreshCartDrawer === 'function') {
          window.refreshCartDrawer(true);
        }
        var headerCart = document.querySelector('header-cart');
        if (headerCart && typeof headerCart.updateCart === 'function') {
          headerCart.updateCart();
        }
      })
      .catch(function(err) {
        console.error('Error adding to cart:', err);
        var card = atb.closest('.sjs-pc');
        var link = card ? card.querySelector('.sjs-pc__title-link') : null;
        if (link && link.href) window.location.href = link.href;
      })
      .finally(function() {
        atb.classList.remove('sjs-loading');
        atb.disabled = false;
      });
    }
  });

  function syncHearts() {
    try {
      var raw = localStorage.getItem('sjs_wl') || '[]';
      var list = JSON.parse(raw);
      document.querySelectorAll('[data-sjs-wishlist]').forEach(function(btn) {
        var id = btn.getAttribute('data-sjs-wishlist');
        btn.classList.toggle('sjs-active', list.indexOf(id) > -1);
      });
    } catch(e) {}
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', syncHearts);
  } else {
    syncHearts();
  }
  document.addEventListener('shopify:section:load', syncHearts);
})();
